import { useMutation, useQueryClient } from "@tanstack/react-query";
import { FinanceKeys } from "web_myplann/Api/Finances/financeKeys";
import type { ExpensesQueryData } from "web_myplann/Api/Finances/useExpenseQuery";
import {
	type ClientExpenseDetailResponseDTO,
	type ClientFinancialPlanExpenseCreateRequestDTO,
	postClientFinancialPlanExpensesV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useCreateExpenseMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(
			(requestContract: ClientFinancialPlanExpenseCreateRequestDTO) =>
				postClientFinancialPlanExpensesV2(requestContract),
		),
		onSuccess: (response: ClientExpenseDetailResponseDTO | undefined) => {
			const previous = queryClient.getQueryData<ExpensesQueryData>(
				FinanceKeys.expense(),
			);
			if (!response || !previous) {
				queryClient.invalidateQueries({ queryKey: FinanceKeys.expense() });
				return;
			}
			queryClient.setQueryData<ExpensesQueryData>(FinanceKeys.expense(), {
				meta: { ...previous.meta, totalCount: previous.data.length + 1 },
				data: [...previous.data, response],
			});
		},
	});
};
